import { useNavigation } from '@react-navigation/native';
import { BaseText, ListItem, Meta, theme, Toggle } from 'aimo-ui';
import { VEHICLE_INPUT_ICON_SIZE } from 'components/account/vehicle/VehicleIcons';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVehicleStore } from 'stores/vehicleStore';
import styled from 'styled-components/native';
import { VoidCallBack } from 'types/common';
import { RootNavProps } from 'types/navigation';

type VehicleCameraRecognitionSelectorProps = {
  selectedCameraRecognition: boolean;
  isOnboarding?: boolean;
};

const IconWrapper = styled.View`
  margin-left: 20px;
`;

const ToggleInput = styled.View`
  margin-right: 20px;
`;

const CameraRecognitionIcon = () => (
  <IconWrapper>
    <Icon
      name="CCTV-Outlined"
      size={VEHICLE_INPUT_ICON_SIZE}
      color={theme.colors.black}
    />
  </IconWrapper>
);

const Toggler = ({
  selectedCameraRecognition,
  handlePress,
}: {
  selectedCameraRecognition: boolean;
  handlePress: VoidCallBack;
}) => {
  const { t } = useTranslation();

  return (
    <ToggleInput>
      <Toggle
        value={selectedCameraRecognition}
        onValueChange={handlePress}
        accessibilityLabel={t('vehicle.cameraRecognition.title')}
        accessibilityRole="switch"
        accessibilityState={{ checked: selectedCameraRecognition }}
      />
    </ToggleInput>
  );
};

const VehicleCameraRecognitionSelector = ({
  selectedCameraRecognition,
  isOnboarding = false,
}: VehicleCameraRecognitionSelectorProps) => {
  const { t } = useTranslation();
  const { setVehicleData } = useVehicleStore((state) => state);
  const { navigate } = useNavigation<RootNavProps>();

  const handlePress = () => {
    if (isOnboarding) {
      navigate('onboardingModal', {
        screen: 'vehicleCameraRecognitionOnboarding',
      });
    } else if (!selectedCameraRecognition) {
      navigate('vehicleCameraRecognitionParking');
    } else {
      setVehicleData({
        cameraRecognition: {
          allowed: false,
          enabled: false,
        },
      });
    }
  };

  const titleComponent = () => (
    <>
      <BaseText>{t('vehicle.cameraRecognition.title')}</BaseText>
      <Meta color={theme.colors.gray300} testID="vehicle-cameraRecognition">
        {selectedCameraRecognition
          ? t('vehicle.cameraRecognition.allowed')
          : t('vehicle.cameraRecognition.notAllowed')}{' '}
      </Meta>
    </>
  );

  return (
    <ListItem
      testID="edit-vehicle-cameraRecognition"
      onPress={handlePress}
      withBorderRadius={true}
      accessible={false}
      accessibilityLabel={t('vehicle.cameraRecognition.title')}
      borderColor={theme.colors.gray100}
      item={null}
      titleComponent={titleComponent}
      indexValue={0}
      rightContentComponent={() => (
        <Toggler
          selectedCameraRecognition={selectedCameraRecognition}
          handlePress={handlePress}
        />
      )}
      iconComponent={CameraRecognitionIcon}
    />
  );
};

export default VehicleCameraRecognitionSelector;
